//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../RoutingCommon/RoutingCommon.TransformBlockBuilder.js";
import "../no/Routing.js";
let d=[[[0,"ActiveEditSegmentType",1,0],[0,"ActiveMotionType",1,0],[0,"BendAngle",1,0],[0,"MaintainAngle",1,0],[0,"MaintainLength",1,0],[1,"PointSelection",0,"Routing.RouteObjectCollector",0],[0,"Segment",1,"Routing.ISegment",0],[0,"SegmentLength",1,0],[1,"TransformTool",0,"RoutingCommon.TransformBlockBuilder",0]],[[[],"StartDrag",{},0,0],[[],"DragObjects",{},0,0],[[],"StopDrag",{},0,0],[[],"ResetDrag",{},0,0]],[]];
SPLM.RoutingCommon.EditPointBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.EditPointBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.EditPointBuilder.Motiontype = Object.freeze({
    "MovePoint" : "MovePoint", "EditSegment" : "EditSegment"});

SPLM.RoutingCommon.EditPointBuilder.Editsegmenttype = Object.freeze({
    "None" : "None", "Length" : "Length", "Angle" : "Angle"});

export default SPLM;